import { render, staticRenderFns } from "./_CompanyDocumentation.vue?vue&type=template&id=36c73df4&"
import script from "./_CompanyDocumentation.vue?vue&type=script&lang=ts&"
export * from "./_CompanyDocumentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports